module.exports = __webpack_public_path__ + "img/green-fields.807965a6.png";